// extracted by mini-css-extract-plugin
module.exports = {"navbar":"LoginNavbar_navbar__3b836","logo":"LoginNavbar_logo__3IPg2"};